import { createOptionalContext } from '../../utils/create-optional-context.js';
const [FetchContext, FetchContextConsumer, FetchContextProvider, useFetch,] = createOptionalContext('FetchContext');
export { FetchContext, FetchContextConsumer, FetchContextProvider, useFetch, };
//# sourceMappingURL=fetch-context.js.map